import workshop from "../static/classes/workshop.png";
import summerweek1 from "../static/classes/summerweek1.png";
import personal from "../static/classes/personal.png";
import bench from "../static/classes/bench.png";
import tryout from "../static/classes/tryout.png";
import ringintensive from "../static/classes/ringintensive.png";
import stackingrings from "../static/classes/stackingrings.png";


export const inPersonClasses = [
  {
    title: "Wax carving workshop - 3.5 hours",
    description:
      "Have you been dreaming about the perfect piece of jewellery, but you just can’t find it anywhere? It’s time to make it yourself!",
    description_nl:
      "Droom je van het perfecte sieraad, maar kun je het nergens vinden? Tijd om het zelf te maken!",
    image: workshop,
    identifier: "wax-carving-workshop",
    tags: [],
    salesPageReleased: true,
  },
  {
    title: "Wax carving week - 5 days",
    description:
      " Immerse yourself for 5 full days in wax carving! Learn different skills and techniques, work with different waxes, and make all kinds of different jewellery pieces in the process!",
    description_nl:
      "Dompel jezelf 5 dagen onder in de wereld van wax carving! Leer verschillende technieken, werk met diverse soorten was, en maak allemaal verschillende sieraden!",
    image: summerweek1,
    identifier: "wax-carving-week",
    tags: [],
    salesPageReleased: true,
  },
  {
    title: "Personal class - 6 hours",
    description:
      "A personal class can be completely customized to what you want to learn!",
    description_nl:
      "Een personal class wordt helemaal aangepast aan wat jij wilt leren!",
    image: personal,
    identifier: "personal-class",
    tags: [],
    salesPageReleased: true,
  },
  {
    title: "Ring Intensive - 3 hours for 8 weeks",
    identifier: "ring-intensive",
    description:
      "Learn to wax carve different kinds of rings and start carving your own designs during this ring focussed course of 8 lessons.",
    description_nl:
      "Leer verschillende soorten ringen wax carven en begin je eigen ontwerpen te maken tijdens deze ringgerichte cursus van 8 lessen.",
    image: ringintensive,
    tags: [],
    salesPageReleased: true,
  },
  {
    title: "Rent a bench",
    identifier: "rent-a-bench",
    description:
      "Don't have space or tools at home to work on your wax carving project? Work on it in my studio!",
    description_nl:
      "Geen ruimte of gereedschap om thuis aan je wax carving project te werken? Kom aan je project werken in mijn atelier!",
    image: bench,
    tags: [],
    salesPageReleased: true,
  },
  {
    title: "Wax tryouts",
    identifier: "wax-tryouts",
    description:
      "Try out all kinds of different waxes and find out which ones are worth getting for your own work!",
    description_nl:
      "Probeer allerlei verschillende soorten was uit en ontdek welke de moeite waard zijn voor je eigen werk!",
    image: tryout,
    tags: [],
    salesPageReleased: false,
  },
  {
    title: "Ring Carving Kit",
    identifier: "ring-carving-kit",
    description:
      "Ring carving kit with all the tools you need to start carving your own rings!",
    description_nl:
      "Ring carving kit met alle tools die je nodig hebt om je eigen ringen te gaan carven!",
    image: stackingrings,
    tags: [],
    unlisted: true,
    salesPageReleased: false,
  },
];
